import e from"../colors/index.js";var o={textColor:{default:e.blue[500],hovered:e.blue[600],disabled:e.grey[400]}};export{o as default};
